import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

export default {
  namespaced: true,
  state () {
    return {
      password: '',
      confirm: '',
      unauthorized: true,
      selected: undefined
    }
  },
  getters,
  mutations,
  actions
}
